import { toast } from 'react-toastify'
import { useEffect, useState, KeyboardEvent } from 'react'
import {
  getSendIvitation,
  postSendIvitation,
} from '../../services/SendIvitation/getSendIvitation'

export const useSendIvitation = () => {
  const XTENANTID = localStorage.getItem('X-TENANT-ID')
  const useOrg = XTENANTID != null ? XTENANTID.slice(1, -1) : ' '

  const [sendIvitation, setSendIvitation] = useState<GetSendIvitationType[]>()
  const [openModal, setOpenModal] = useState(false)
  const [openModal2, setOpenModal2] = useState(false)
  const [closedSend, setClosedSend] = useState(false)
  const [value, setValue] = useState('')
  const [emails, setEmails] = useState<string[]>([])
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])
  const [formatoDeEmail, setformatoDeEmail] = useState(false)

  const fetchUseSendIvitation = async () => {
    const result = await getSendIvitation()

    if ('message' in result) {
      if (result.message === 'Usuário não autenticado') {
        // redireciona para a página de login
        window.location.href = '/logout'
      } else {
        toast.error(result.message)
      }
    } else {
      setSendIvitation(result)
    }
  }
  const usuarioConviteRequestDTO = {
    emails: selectedOptions && emails,
  }

  const enviaEmail = async () => {
    const result = await postSendIvitation(usuarioConviteRequestDTO, useOrg)
    if ('info' in result) {
      setOpenModal(true)
      return
    }
    setOpenModal2(true)
    toast.error(result.message)
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const digitado = e.target.value
    // const sendIvitationEmails = sendIvitation?.map(option => option.email) || []

    // const users: string[] = []
    // users.push(...sendIvitationEmails)

    const user = []
    // users.filter(item =>
    //   item.toLowerCase().startsWith(value.toLowerCase())
    // )
    user.push(digitado)
    setValue(() => digitado)
    setEmails(user)
  }

  function handleSelectOption(option: string) {
    setSelectedOptions([...selectedOptions, option]) // adiciona a opção selecionada ao estado
    setValue('') // limpa o campo de texto
    setEmails([]) // limpa as sugestões
  }

  const handleKeyDownEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSelectOption(value)
    }
  }

  const handleKeyDownOption = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      emails.map(option => handleSelectOption(option))
    }
  }

  function handleDeleteOption(option: string) {
    const newSelectedOptions = selectedOptions.filter(item => item !== option)
    setSelectedOptions(newSelectedOptions)
  }

  // const { handleSubmit, onSubmit } = useNewUsers()

  useEffect(() => {
    fetchUseSendIvitation()
  }, [])

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (openModal) {
      const timer = setTimeout(() => {
        window.location.reload()
      }, 4000)
      return () => clearTimeout(timer)
    }
    if (openModal2) {
      const timer = setTimeout(() => {
        window.location.reload()
      }, 4000)
      return () => clearTimeout(timer)
    }
  }, [openModal || openModal2])

  return {
    sendIvitation,
    openModal,
    setOpenModal,
    openModal2,
    setOpenModal2,
    closedSend,
    setClosedSend,
    value,
    setValue,
    emails,
    setEmails,
    selectedOptions,
    setSelectedOptions,
    handleDeleteOption,
    handleKeyDownOption,
    handleKeyDownEnter,
    handleChange,
    handleSelectOption,
    enviaEmail,
    formatoDeEmail,
    setformatoDeEmail,
  }
}
